export default {
    allLocations: [],
    assignmentArea: [],
    callTypes: [],
    isLoading: false,
    isLoaded: true,
    isFormValid: true,
    isTableValid: true,
    colorSchemeId: 1,
    colorSchemes: require('../color-schemes.json'),
    navCollapsed: false,
    expandedWidgetId: null,
    expandedWidgetSelect: null,
    expandedWidget: null,
    unsavedChanges: false,
    selectedReportType: 0,
    staff: [],
    superUserAreas: [],
    mariTimeout: null, // auto logout
    mariCurrentTime: null, // time on falcon system
    timeFormat: {
        date: 'yyyy-MM-dd',
        time: 'HH:mm:ss',
        separator: '/',
    },
    onKeyDownHandlers: [],
    dutySelector: {},
    updateData: () => Promise.resolve(),
    assignmentsConf: {},
    logSettings: [],
    targetTimeCalls: [],
    dragging: false,
    dropAllowing: false,
    defaultRecipients: [],
};
